import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomSelect from "../input/select";
import "./modal.scss";
import CustomeInput from "../input/input";
import { hasDangerousCode } from "../../utils/utils";
import classNames from "classnames";

const Input = ({
  name,
  error,
  validation,
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const handleOnChange = (e) => {
    const hasError = validation(e, columnDataArr);
    if (!hasError) {
      childHasError(true);
      setError(true);
    } else {
      childHasError(false);
      setError(false);
    }
    props.onChange(e);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
      >
        <textarea
          className={classNames(classes.input, `input${tableName}`)}
          rows={2}
          style={{ width: "100%", marginBottom: "-20px" }}
          name={name}
          value={value || ""}
          onChange={handleOnChange}
        />
        <p className={classNames(classes.error, `error${tableName}`)}>
          {hasError && error}
        </p>
      </div>
    </>
  );
};

export default function CustomModal(props) {
  const PRIMARY_COLUMN = props.sourceDropdownData.table_primary_key || "";
  const [open, setOpen] = useState(props.openModel);
  const [mode, setMode] = useState(true);
  const [modelData, setData] = useState(props.modelData);
  const [rowHasError, setRowHasError] = useState(false);
  const [editedRowData, setEditedRowData] = useState({
    [PRIMARY_COLUMN]: modelData?.[PRIMARY_COLUMN],
  });

  const DROPDOWN_LIST = props.sourceDropdownData;
  const DROPDOWN_DATA = props.sourceData?.data?.dropdown || {};
  const Edit_Column_Module = DROPDOWN_DATA?.edit_model_column_list || [];
  const MODAL_LABELS = props.sourceDropdownData.edit_model_column_list.filter(
    (item) => item.label !== "Item Descrption" && item.label !== "UPC",
  );
  const CurrentDimension = props.sourceData?.current_dimension?.label || "";
  const TITLE_COLUMNS =
    props.sourceData?.data?.dropdown?.edit_dialog_title_columns || [];

  const [customStyles, setCustomStyles] = useState({
    menuPortal: (base) => ({
      ...base,
      maxHeight: "90%",
      fontSize: 12,
      fontFamily: "Hind Siliguri !important",
      zIndex: 9999,
    }),
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    props.closeModel();
  };

  const handleSelectOnChange = (key, val) => {
    const updatedData = Object.assign({}, modelData, {
      [key]: val,
    });
    setEditedRowData((prev) => ({
      ...prev,
      [key]: val,
    }));
    setData(updatedData);
  };

  const handleInputOnChange = (key, val) => {
    const ColumnValue = val || "";
    const ALLOWED_SPECIAL_CHARACTERS =
      DROPDOWN_DATA?.allowed_special_characters || "";
    const hasExplicitDanger = hasDangerousCode(
      ColumnValue,
      ALLOWED_SPECIAL_CHARACTERS,
    );

    if (hasExplicitDanger && !hasExplicitDanger?.isValid) {
      props.updateAlert({
        open: true,
        message: `${hasExplicitDanger?.error}`,
        severity: "error",
        closeFlag: true,
      });
      return false;
    }

    const updatedData = Object.assign({}, modelData, {
      [key]: val,
    });
    setEditedRowData((prev) => ({
      ...prev,
      [key]: val,
    }));
    setData(updatedData);
    return true;
  };

  const handleEdit = (e) => {
    setMode(false);
  };

  const handleSave = (e) => {
    const is_Value_Changed = Edit_Column_Module.some((item) => {
      return modelData[item.name] !== props.modelData[item.name];
    });

    // Index finding to check if item is already in modified_mapped_data
    const MODIFIED_MAPPED_DATA = props.sourceData.modified_mapped_data;
    const index = MODIFIED_MAPPED_DATA.findIndex(
      (item) => item?.[PRIMARY_COLUMN] === modelData?.[PRIMARY_COLUMN],
    );
    const { [PRIMARY_COLUMN]: extractedValue, ...editedItems } = editedRowData;

    if (is_Value_Changed) {
      setMode(false);
      setOpen(false);
      let updatedArray;
      if (index !== -1) {
        //updating the existing object by adding new key: value
        updatedArray = MODIFIED_MAPPED_DATA.map((item, i) =>
          i === index
            ? {
                ...item,
                ...editedItems,
                UPDATED_BY: props.user.mail || "",
              }
            : item,
        );
      } else {
        //adding a new object to the array
        const FinalData = {
          ...editedRowData,
          UPDATED_BY: props.user.mail || "",
        };
        updatedArray = [...MODIFIED_MAPPED_DATA, FinalData];
      }

      const updatedSourceArray = props.sourceData.current_mapped_data.map(
        (row, i) => {
          return row.rowData?.[PRIMARY_COLUMN] === modelData?.[PRIMARY_COLUMN]
            ? { ...row, rowData: { ...row.rowData, ...editedItems } }
            : row;
        },
      );

      //Updating the redux store with final result
      props.updateSourceInputs("modified_mapped_data", updatedArray);
      props.updateSourceInputs("current_mapped_data", updatedSourceArray);
      props.setGlobalEdit(true);

      props.closeModel();
    } else {
      props.updateAlert({
        open: true,
        message: "No Value has been changed",
        severity: "error",
        closeFlag: true,
      });
    }
  };

  const handleValidate = () => {
    return true;
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          {(modelData &&
            TITLE_COLUMNS?.length > 0 &&
            TITLE_COLUMNS.map((item) => {
              const value = modelData?.[item.name];

              return value !== null &&
                value !== undefined &&
                value !== "" &&
                value !== "null"
                ? value
                : `${item.label} is Empty`;
            }).join(" - ")) ||
            "Edit"}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            <div className="table-fields-container">
              {MODAL_LABELS &&
                MODAL_LABELS.map((item, index) => {
                  const SELECT_OPTIONS = DROPDOWN_LIST[item.name]
                    ? DROPDOWN_LIST[item.name]
                    : [];
                  return (
                    <div className="table-fields-select" key={`model-${index}`}>
                      {item.type === "select" ? (
                        <CustomSelect
                          classes={{
                            ...props.selectClasses,
                          }}
                          tableName={props.tableName}
                          name={item.name}
                          onChange={handleSelectOnChange}
                          options={SELECT_OPTIONS}
                          customStyles={customStyles}
                          value={
                            modelData[item.name] &&
                            typeof modelData[item.name] === "object"
                              ? JSON.stringify(modelData[item.name])
                              : modelData[item.name] || ""
                          }
                          error={item.error}
                          selectMessage={item.label}
                          validation={item.validation}
                          readonly={mode}
                        />
                      ) : item.type === "input" ? (
                        <CustomeInput
                          columnDataArr={modelData[item.name]}
                          tableName={props.tableName}
                          showLabel={false}
                          classes={{ ...props.inputClasses }}
                          type={item.type}
                          name={item.name}
                          label={item.label}
                          onChange={handleInputOnChange}
                          value={
                            modelData[item.name] &&
                            typeof modelData[item.name] === "object"
                              ? JSON.stringify(modelData[item.name])
                              : modelData[item.name] || ""
                          }
                          item={item.name}
                          error={item.error}
                          validation={item.validation}
                          childHasError={(bool) => setRowHasError(bool)}
                          readonly={mode}
                        />
                      ) : item.type === "textarea" ? (
                        <Input
                          columnDataArr={modelData[item.name]}
                          tableName={props.tableName}
                          classes={{}}
                          type={item.type}
                          name={item.name}
                          onChange={(e) =>
                            handleInputOnChange(item.name, e.target.value)
                          }
                          value={
                            modelData[item.name] &&
                            typeof modelData[item.name] === "object"
                              ? JSON.stringify(modelData[item.name])
                              : modelData[item.name] || ""
                          }
                          item={item.name}
                          childHasError={(bool) => setRowHasError(bool)}
                          error={item?.error || ""}
                          validation={handleValidate}
                        />
                      ) : (
                        <CustomeInput
                          columnDataArr={modelData[item.name]}
                          tableName={props.tableName}
                          showLabel={false}
                          classes={{ ...props.inputClasses }}
                          type={item.type}
                          name={item.name}
                          label={item.label}
                          onChange={handleInputOnChange}
                          value={
                            modelData[item.name] &&
                            typeof modelData[item.name] === "object"
                              ? JSON.stringify(modelData[item.name])
                              : modelData[item.name] || ""
                          }
                          item={item.name}
                          error={item.error}
                          validation={item.validation}
                          childHasError={(bool) => setRowHasError(bool)}
                          readonly={true}
                        />
                      )}
                    </div>
                  );
                })}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {mode ? (
            <>
              <Button onClick={handleEdit}>Edit</Button>
            </>
          ) : (
            <Button onClick={handleSave}>Save</Button>
          )}
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
